/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating } from './FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating';
import {
    instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating,
    FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingFromJSON,
    FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingFromJSONTyped,
    FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingToJSON,
} from './FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating';

/**
 * @type FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRating
 * Рейтинг по звездам (1-5)
 * @export
 */
export type FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRating = FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating;

export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRating {
    return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRating {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingToJSON(json: any): any {
    return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRating | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingToJSON(value as FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating);
    }

    return {};
}

